<template>
  <!-- 首页 -->
  <div class="pageapp">
    <a-card class="card">
      <water-map></water-map>
    </a-card>
    <a-row :gutter="16">
      <a-col class="gutter-row" :span="6">
        <a-card class="card-top">
          <Homebottomeft></Homebottomeft>
        </a-card>
      </a-col>
      <a-col class="gutter-row" :span="6">
        <a-card class="card-top">
          <Homebottomright></Homebottomright>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import waterMap from './component/map.vue'
import Homebottomeft from './component/Homebottomeft.vue'
import Homebottomright from './component/Homebottomright.vue'
export default {
  components: {
    waterMap,
    Homebottomeft,
    Homebottomright
  },
  created () {
    this.setSystemName()
  },
  methods: {
    init () { },
    setSystemName () {
      this.$store.commit('SET_SYSTEMNAME', `${this.$store.getters.userInfo.realName}二次供水系统`)
    }
  }
}
</script>

<style lang='less' scoped>
/deep/.ant-card-body {
  padding: 0;
}

.pageapp {
  width: 100%;
  height: 100%;
}

.card {
  width: 97.4%;
  height: 600px;
  margin: 0 auto;
  margin-bottom: 20px;
}

.card-top {
  width: 100%;
  height: 300px;
}

.gutter-row {
  width: 48%;
  height: 250px;
  margin-left: 20px;
}
</style>
